module.exports = __webpack_public_path__ + "img/birthday-card.76ed49b4.png";